import { ReactNode } from "react";
import Carousel, { OverflowCarousel } from "@ingka/carousel";

import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/carousel/dist/style.css";
import "@ingka/focus/dist/style.css";

type FixaOverflowCarouselProps = {
  children?: ReactNode;
  id?: string;
  controlBtnType?:
    | "primary"
    | "emphasised"
    | "secondary"
    | "tertiary"
    | "danger"
    | "plain"
    | "image-overlay";
  "data-testid"?: string;
  slideIndex?: number;
};

export function FixaOverflowCarousel(props: FixaOverflowCarouselProps) {
  return <OverflowCarousel {...props} />;
}

type FixaCarouselProps = {
  children?: React.ReactElement[];
  hasNoControls?: boolean;
  id: string;
  isSlideShow?: boolean;
  onVisibleSlideChange?: (visibleIndices: number[]) => void;
  ariaLabelLeftBtn?: string;
  ariaLabelRightBtn?: string;
  "data-testid"?: string;
  slideIndex?: number;
  className?: string;
  hasSlideCounter?: boolean;
};
function FixaCarousel(props: FixaCarouselProps) {
  return (
    <Carousel {...props} hasSlideCounter={props.hasSlideCounter ?? false} />
  );
}

export default FixaCarousel;
